/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs */

const en__field__enum_schoolname_gymnasium_oberursel3 = /** @type {(inputs: _Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberursel`)
};

const de__field__enum_schoolname_gymnasium_oberursel3 = /** @type {(inputs: _Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gymnasium Oberursel`)
};

/**
* | output |
* | --- |
* | "Oberursel" |
*
* @param {_Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_gymnasium_oberursel3 = /** @type {((inputs?: _Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Gymnasium_Oberursel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_gymnasium_oberursel3(inputs)
	return de__field__enum_schoolname_gymnasium_oberursel3(inputs)
});
export { _field__enum_schoolname_gymnasium_oberursel3 as "_field__enum_schoolName_Gymnasium_Oberursel" }